<!--/*
* @name: 问题建议
* @description: 问题建议
* @author: zefeng(zefeng.chen@shengyc.com)
* @Date: 2019-08-22 19:33:09
* @LastEditTime: 2019-08-22 19:33:09
*/
 -->
<template>
  <div id="suggest-details-container">
    <div id="headerMenuBox">
      <nav-header headTitle="问题与建议" bg="#0152b4" color="#ffffff">
        <a
          href="javascript:;"
          class="nav-btn_left"
          slot="head_left"
          @click="$_goBack"
        />
      </nav-header>
    </div>
    <div v-show="!showSuccessful" class="surface">
      <div class="title">请给出您宝贵的建议！</div>
      <textarea
        v-model="advice"
        name
        id="inputBox"
        placeholder="请填写意见或建议，限长200字"
      ></textarea>
      <div class="taking-pictures">
        <span class="label">上传图片</span>
        <van-uploader v-model="fileList" multiple :max-count="5" />
        <!-- <div class="picture">
          <img src="../../assets/images/ic_camera.png" alt="" />
          <span>上传图像</span>
        </div>-->
      </div>
    </div>
    <div class="successful" v-show="showSuccessful">
      <img class="remind" src="../../assets/images/information.png" alt />
      <div class="successful-text">提交成功！</div>
      <div class="thank">感谢您的支持</div>
      <div class="thank">我们将竭诚为您提供更优质的服务</div>
    </div>
    <div class="footer">
      <button @click="$_submit">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
import { pathOr } from '@/config/Utils';
import NavHeader from '@/components/NavHeader/NavHeader.vue';
export default {
  name: 'Suggest',
  components: {
    NavHeader
  },
  data() {
    return {
      pathOr: pathOr,
      fileList: [],
      suggestData: {},
      showSuccessful: false,
      buttonText: '提交',
      advice: '' //问题
    };
  },
  created() {},
  mounted() {},
  methods: {
    $_goBack() {
      this.$router.back();
    },
    $_submit() {
      if (!this.advice) {
        this.$toast('建议内容不能为空');
        return false;
      }
      if (this.showSuccessful) {
        this.$_goBack();
      } else {
        this.$store.commit('setLoading', { flag: true, loadingText: '提交中' });
        setTimeout(() => {
          this.$store.commit('setLoading', { flag: false });
          this.showSuccessful = true;
          this.buttonText = '返回';
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/style/mixin';
#suggest-details-container {
  .van-uploader__upload {
    width: vw(64);
    height: vw(64);
    margin-left: vw(12);
  }
  .van-uploader__preview-image {
    width: vw(64);
    height: vw(64);
  }
  @include fja(flex-start, flex-start);
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  #headerMenuBox {
    display: flex;
    flex-direction: column;
    .nav-btn_left {
      @include wh(vw(44), vw(44));
      display: block;
      background: transparent url('../../assets/images/left_arrow.png')
        no-repeat center center;
      background-size: vw(10), vw(18);
    }
  }
  .surface {
    background: #ffffff;
    width: 100%;
    padding-left: vw(16);
    padding-right: vw(16);
    flex: 1;
    .title {
      padding-top: vw(24);
      padding-bottom: vw(14);
      padding-left: vw(8);
      padding-right: vw(8);
      font-size: vw(15);
      border-bottom: 1px solid #eeeeee;
    }
    #inputBox {
      margin-top: vw(16);
      border: solid 1px #cccccc;
      resize: none;
      width: 100%;
      height: vw(160);
      padding: vw(16);
      font-size: vw(14);
      &::placeholder {
        color: #999999;
        font-size: vw(14);
      }
    }
    .taking-pictures {
      margin-top: vw(20);
      @include fja(flex-start, flex-start);
      .label {
        margin-top: vw(6);
        font-size: vw(14);
        color: #666666;
      }
      .picture {
        margin-left: vw(12);
        width: vw(64);
        height: vw(64);
        border: 1px dashed #cccccc;
        @include fja;
        flex-direction: column;
        span {
          font-size: vw(10);
          color: #999999;
          margin-top: vw(6);
        }
        img {
          width: vw(27);
          height: vw(24);
        }
      }
    }
  }
  .successful {
    background: #ffffff;
    width: 100%;
    padding-left: vw(16);
    padding-right: vw(16);
    flex: 1;
    @include fja(center, center);
    flex-direction: column;
    .remind {
      width: vw(44);
      height: vw(28);
    }
    .successful-text {
      margin-top: vw(20);
      font-size: vw(16);
      color: #333333;
    }
    .thank {
      font-size: vw(14);
      color: #999999;
    }
    .thank:nth-of-type(2) {
      margin-top: vw(86);
    }
    .thank:nth-of-type(3) {
      margin-top: vw(10);
    }
  }
  .footer {
    background: #ffffff;
    width: 100%;
    margin-top: vw(8);
    padding: vw(8) vw(16);
    button {
      width: 100%;
      background-color: #0152b4;
      border-radius: vw(4);
      color: #ffffff;
      font-size: vw(15);
      padding: vw(15) 0;
    }
  }
}
</style>
